// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstPlanillaRecorrido = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_insumo_repartido',
        name: 'mov_insumo',
        component: ViewLstPlanillaRecorrido,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
